/**
 * Auctions labels
 * Dynamic mapping from JSON based on current language
 */

import svAuctions from '../locales/sv/auctions.json';
import enAuctions from '../locales/en/auctions.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getAuctionsLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enAuctions : svAuctions;
};

export const auctionsLabels = (lang?: Language) => {
  return getAuctionsLocale(lang);
};
